export default {

  // 应用示范列表
  getExampleList(params, success) {
    Request.GET('/application/example', params, response => success(response));
  },

  // 查询应用示范详情
  getExampleDetail(id, success) {
    Request.GET(`/application/example/${id}`, null, response => success(response));
  },

  // 查询应用示范详情上下篇
  getPrevNextExample(id, success) {
    Request.GET(`/application/example/${id}/link`, null, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/exampleApi.js